import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  max-width: 379px;

  color: ${theme.colors.white};
`;

export const Title = styled.h1`
  font-size: ${theme.font.sizes.xsmall};
  margin-bottom: 30px;
`;

export const Text = styled.p`
  text-align: center;
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.normal};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export const Button = styled.button`
  border: none;
  padding: 8px 32px;
  border-radius: ${theme.border.radius};

  color: ${theme.colors.white};
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.normal};
  font-family: ${theme.font.poppins};

  background-color: ${({ color }) =>
    color && theme.colors[color as keyof typeof theme.colors]};

  transition: filter 0.3s ease-in-out;

  &:hover {
    filter: brightness(0.8);
  }
`;
